import type { AccountingType } from 'v2-types/order';

export const NET_PROCEEDS_CODES = ['net_proceeds', 'netproceeds_buyer', 'netproceeds_seller'];

export const isNetProceedsCode = (code?: string | null): boolean => (
  !!code && NET_PROCEEDS_CODES.includes(code)
);

type LetterNumberEntry = Pick<AccountingType, 'letter' | 'number' | 'code'>;

// Runtime API payloads may carry an empty letter / nullish number despite the TS types.
// number = 0 is a valid number.
const hasValidLetterAndNumber = (entry: LetterNumberEntry): boolean => (
  typeof entry.letter === 'string'
  && entry.letter.trim() !== ''
  && entry.number !== null
  && entry.number !== undefined
);

// An entry can be linked when it has a letter + number. Net Proceeds entries have none,
// so they are also allowed when creating disbursements.
export const canLinkEntry = (entry: LetterNumberEntry | undefined, kindEntry: string[]): boolean => {
  if (!entry) return false;
  if (hasValidLetterAndNumber(entry)) return true;
  return kindEntry.includes('disbursement') && isNetProceedsCode(entry.code);
};
